import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';
import { heroBannerStyles } from './HeroBanner.styles';

export type HeroBannerProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  ctaLabel: string;
  ctaHref: string;
  imageSrc?: string;
  className?: string;
};

export function HeroBanner({
  eyebrow,
  title,
  description,
  ctaLabel,
  ctaHref,
  imageSrc,
  className,
}: HeroBannerProps): JSX.Element {
  return (
    <section className={cn(heroBannerStyles.root, className)}>
      <div className={heroBannerStyles.media} aria-hidden>
        {imageSrc ? (
          <img src={imageSrc} alt="" className={heroBannerStyles.image} />
        ) : (
          <div className={heroBannerStyles.toneFallback} />
        )}
        <div className={heroBannerStyles.overlay} />
      </div>
      <div className={heroBannerStyles.content}>
        {eyebrow ? <p className={heroBannerStyles.eyebrow}>{eyebrow}</p> : null}
        <h1 className={heroBannerStyles.title}>{title}</h1>
        {description ? <p className={heroBannerStyles.description}>{description}</p> : null}
        <div className={heroBannerStyles.actions}>
          <Link to={ctaHref}>
            <Button type="button" size="lg">
              {ctaLabel}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
